import React from 'react';
import { isEmpty } from 'lodash';
import { AUTH_BACKUP_CODE_LABEL } from 'common/constants/login';
import { AuthenticationBackupCodesInputProps } from './AuthenticationBackupCodesInput.props';
import { StyledHelperText, StyledTextField } from './AuthenticationBackupCodesInput.styles';

const AuthenticationBackupCodesInput = ({ formState, handleChange }: AuthenticationBackupCodesInputProps) => {
  const { values, errors } = formState;
  const hasError = errors?.backupCode !== undefined && errors.backupCode.length > 0;
  const helperText = isEmpty(errors?.backupCode) ? null : errors.backupCode;

  return (
    <StyledTextField
      id="enter-user-backup-code"
      name="backupCode"
      variant="standard"
      value={values.backupCode || ''}
      label={AUTH_BACKUP_CODE_LABEL}
      fullWidth
      type="text"
      error={hasError}
      required
      helperText={helperText && <StyledHelperText>{helperText}</StyledHelperText>}
      onChange={handleChange}
    />
  );
};

export default AuthenticationBackupCodesInput;
